import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(23 * 60 + 59); // 23 min 59 sec
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  if (!isVisible) return null;
  return <AnimatePresence data-id="element-313">
      <motion.div initial={{
      y: -50
    }} animate={{
      y: 0
    }} className="fixed top-0 left-0 w-full z-50 bg-black border-b border-yellow-500/50 px-4 py-2 shadow-lg" data-id="element-314">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 text-center sm:text-left" data-id="element-315">
          <div className="flex items-center gap-2" data-id="element-316">
            <span className="relative flex h-3 w-3" data-id="element-317">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-318"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-red-600" data-id="element-319"></span>
            </span>
            <span className="text-white font-bold text-sm uppercase tracking-wide" data-id="element-320">
              OFERTA LIMITADA:{' '}
              <span className="text-yellow-500" data-id="element-321">Solo quedan 47 copias</span>
            </span>
          </div>

          <div className="flex items-center gap-2 bg-zinc-900 px-3 py-1 rounded border border-zinc-800" data-id="element-322">
            <span className="text-zinc-400 text-xs uppercase font-bold" data-id="element-323">
              Expira en:
            </span>
            <span className="text-yellow-500 font-mono font-bold text-lg leading-none" data-id="element-324">
              {formatTime(timeLeft)}
            </span>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>;
}